import { Grid } from "@chakra-ui/react"
import React, { PropsWithChildren } from "react"

interface Props extends PropsWithChildren {}

const CloudImageBrowserGrid: React.FC<Props> = ({ children }) => {
  return (
    <Grid
      width="full"
      templateColumns="repeat(auto-fill, minmax(165px, 1fr))"
      gap={2}
    >
      {children}
    </Grid>
  )
}

export default CloudImageBrowserGrid
